var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center",attrs:{"id":"main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 message"},[_c('p',[_vm._v(" Please close your browser to sign out of myCSUB session ")])])])])
}]

export { render, staticRenderFns }